var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isEmulating)?_c('div',{staticClass:"emulation-warning"},[_vm._v("Emulating: "+_vm._s(_vm.user.name))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }